import type {
  HotspotRow,
  StageBarRow
} from '../../../services/interface/pcfTypes';

export const MOCK_STAGE_BREAKDOWN: StageBarRow[] = [
  {label: 'A1', value: 15.0, color: '#6366F1'},
  {label: 'A2', value: 9.6, color: '#8B5CF6'},
  {label: 'A2', value: 10.6, color: '#22D3EE'},
  {label: 'A2', value: 6.4, color: '#10B981'},
  {label: 'A3', value: 1.0, color: '#F59E0B'},
  {label: 'A5', value: 3.8, color: '#EF4444'}
];

export const MOCK_HOTSPOTS: HotspotRow[] = [
  {
    rank: 1,
    process: 'Road - Truck (Diesel) transport',
    stage: 'A2',
    value: 15.62,
    percent: 86.5
  },
  {
    rank: 2,
    process: 'Grid Electricity',
    stage: 'A3',
    value: 2.43,
    percent: 13.5
  },
  {
    rank: 3,
    process: 'Polypropylene (PP) granules',
    stage: 'A1',
    value: 0.0,
    percent: 0.0
  },
  {
    rank: 4,
    process: 'Non-hazardous waste - recycled',
    stage: 'A3',
    value: 0.0,
    percent: 0.0
  },
  {
    rank: 5,
    process: 'Packaging material',
    stage: 'C3',
    value: 0.0,
    percent: 0.0
  }
];

export const MOCK_TOTAL_PCF = 20.52;

export const buildMockResultsExtras = (): {
  totalPcf: number;
  stageBreakdown: StageBarRow[];
  hotspots: HotspotRow[];
} => ({
  totalPcf: MOCK_TOTAL_PCF,
  stageBreakdown: MOCK_STAGE_BREAKDOWN,
  hotspots: MOCK_HOTSPOTS
});
